import React from 'react';
import { Form } from '@/components/ui/form';
import { TextField } from '@/components/text-field';
import { Loader2, Lock, LockOpen, LogIn, Mail } from 'lucide-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthenticationDispatch } from '@/hooks/use-authentication';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { signInSchema } from '@/schema/sign-in-schema';
import { signIn } from '@/services/auth';
import { errorHandler } from '@/lib/utils';
import { t } from 'i18next';
import { Button } from '@/components/ui/button';
import { Link } from '@tanstack/react-router';
export const PasswordForm = () => {
    const queryClient = useQueryClient();
    const dispatch = useAuthenticationDispatch();
    const [showPassword, setShowPassword] = React.useState(false);
    const passwordForm = useForm({
        resolver: yupResolver(signInSchema),
        defaultValues: {
            email: '',
            password: '',
        },
    });
    const passwordMutation = useMutation({
        mutationFn: signIn,
        onSuccess: (data) => {
            dispatch({ type: 'SIGN_IN', user: data.user });
            queryClient.invalidateQueries({ queryKey: ['me'] });
        },
        onError: errorHandler,
    });
    return (<Form {...passwordForm}>
            <form className="space-y-4" onSubmit={passwordForm.handleSubmit((data) => passwordMutation.mutate(data))} noValidate>
                <TextField control={passwordForm.control} name="email" label={t('email')} placeholder="you@business.com" startIcon={<Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground"/>} required disabled={passwordMutation.isPending} autoComplete="email"/>

                <TextField control={passwordForm.control} name="password" placeholder="••••••••" label={t('password')} type={showPassword ? 'text' : 'password'} disabled={passwordMutation.isPending} endIcon={<Button variant="ghost" size="icon" type="button" onClick={() => setShowPassword((p) => !p)} className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4">
                            {showPassword ? <Lock className="h-4 w-4"/> : <LockOpen className="h-4 w-4"/>}
                        </Button>} labelRight={<Link to="/forgot-password" className="text-xs text-primary hover:underline">
                            {t('forgot_password_question')}
                        </Link>} required autoComplete="current-password"/>

                <Button type="submit" className="w-full" disabled={passwordMutation.isPending}>
                    {passwordMutation.isPending ? (<>
                            <Loader2 className="mr-2 h-4 w-4 animate-spin"/>
                            {t('sign_in.loading', { ns: 'glossary' })}
                        </>) : (<>
                            <LogIn className="mr-2 h-4 w-4"/>
                            {t('sign_in')}
                        </>)}
                </Button>
            </form>
        </Form>);
};
PasswordForm.displayName = 'PasswordForm';
